import { AxiosResponse } from 'axios';
import axios from '../api/axios';
import { AlertsQueryResponse, DataQueryResponse } from './_models';

export const getLastData = (id: number): Promise<DataQueryResponse> => {
  return axios
    .get(`/app/pole/${id}/data`)
    .then((d: AxiosResponse<DataQueryResponse>) => d.data)
    .catch(() => [] as never);
};

export const getAlerts = (id: number): Promise<AlertsQueryResponse> => {
  return axios
    .get(`/app/pole/${id}/alerts`)
    .then((d: AxiosResponse<AlertsQueryResponse>) => d.data)
    .catch(() => [] as never);
};
